import { render } from "./MainProductTraking.vue?vue&type=template&id=c64ba248&scoped=true"
import script from "./MainProductTraking.vue?vue&type=script&lang=js"
export * from "./MainProductTraking.vue?vue&type=script&lang=js"

import "./MainProductTraking.vue?vue&type=style&index=0&id=c64ba248&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64ba248"]])

export default __exports__